import { FlexBox } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { GenreStatsPie } from './GenreStatsPie'
import { GenreStatsPieLabels } from './GenresStatsPieLabels'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  inView: boolean
}

export const GenreStatsContent = ({ inView, ...props }: Props) => {
  const { mediaQueries } = useTheme()

  return (
    <FlexBox
      className={css`
        min-height: 248px;
        margin-top: 20px;
        width: 100%;
        padding-bottom: 15px;
        ${mediaQueries.mobile} {
          padding-bottom: 40px;
        }
      `}
      justifyContent="space-between"
      {...props}
    >
      <div
        className={css`
          position: relative;
          width: 100%;
        `}
      >
        <div
          className={css`
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          `}
        >
          <div
            data-testid="stats-genres-pie"
            className={css`
              height: 180px;
              ${mediaQueries.mobile} {
                height: 220px;
              }
            `}
          >
            <GenreStatsPie inView={inView} />
          </div>
        </div>
      </div>
      <GenreStatsPieLabels />
    </FlexBox>
  )
}
